import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { gradientBackgrounds } from "@/components/AIComponents/AiComponents.style";
import { backgroundLinearGradient } from "@/components/AIComponents/ExportablesModal/ExportablesModal.styles";

const { ui } = constants.colors;
const blue = ui.core[25];
const black = ui.black[100];
const lightGray = ui.neutral[100];

export const leftPanelCss: CSSObject = {
  height: "100%",
  overflowX: "hidden",
  overflowY: "auto",
};

export const imageCss: CSSObject = {
  margin: "5px 5px 0",
  maxWidth: "124px",
  maxHeight: "100%",
  borderRadius: "4px",
  alignSelf: "center",
};

export const checkboxCss: CSSObject = {
  background: ui.white[100],
  padding: "10px 5px",
  fontWeight: 700,
  color: black,
  borderRadius: "0 0 8px 8px",
  "&& > span": {
    marginRight: "6px",
  },
};

/**
 * TODO: Styles for radio button. Remove when the assign_graphic_organizers
 * has been rolled out to 100%
 */
export const radioButtonCss: CSSObject = {
  background: ui.white[100],
  padding: "8px 5px",
  fontWeight: 700,
  color: black,
  borderRadius: "0 0 8px 8px",
  "&& > span": {
    marginRight: "6px",
  },
  "&& > div": {
    textAlign: "left",
    paddingRight: "4px",
  },
};

export const listCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  maxHeight: "100%",
  width: "225px",
  minWidth: "225px",
  overflowY: "auto",
  gap: ".5em",
  padding: 0,
  margin: 0,
  listStyle: "none",
};

export const listItemCss = (isChecked: boolean): CSSObject => ({
  alignItems: "flex-start",
  background: isChecked ? backgroundLinearGradient : lightGray,
  borderRadius: "8px",
  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  overflow: "hidden",
  padding: "2px",
  position: "relative",
  transition: "background 0.5s ease",
  width: "100%",
  /**
   * This ensures that the button background changes on
   * hover/focus of the list item.
   */
  "&:hover button, &:focus button, &:focus-visible button": {
    background: gradientBackgrounds[400],
  },
});

export const buttonCss = (isChecked: boolean): CSSObject => ({
  background: isChecked ? gradientBackgrounds[400] : blue,
  borderRadius: "8px 8px 0 0",
  transition: "background 0.5s ease",
  width: "100%",
  justifyContent: "center",
  padding: "6px 0 10px",

  "&:hover, &:focus, &:focus-visible": {
    background: gradientBackgrounds[400],
  },
});
